import React from 'react';
import { useSiteConfig } from '../contexts/SiteConfigContext';

function CookiesPolicyPage() {
  const { config } = useSiteConfig();
  const owner = config?.legal_owner_name || config?.legal_business_name || 'KREEO';
  const email = config?.legal_email || config?.contact_email || 'ton@kreeo.es';
  const usesGA = !!config?.ga4_measurement_id;
  const usesPlausible = !!config?.plausible_domain;

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="cookies-policy-page">
      <h1 className="text-4xl font-light text-[#374963] mb-8">Política de Cookies</h1>
      <div className="space-y-6 text-[#374963] leading-relaxed">
        <p className="text-sm text-[#73706e]">Última actualización: {new Date().toLocaleDateString('es-ES')}</p>

        <section>
          <h2 className="text-2xl font-semibold mb-3">1. ¿Qué son las cookies?</h2>
          <p>
            Una cookie es un pequeño archivo de texto que un sitio web guarda en tu ordenador o dispositivo móvil
            cuando lo visitas. Permiten que el sitio recuerde tus acciones y preferencias durante un período de tiempo.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">2. Cookies utilizadas en esta web</h2>

          <div className="mt-4 space-y-4">
            <div className="bg-[#F5F1EC] p-4 rounded-lg">
              <h3 className="font-semibold">Cookies técnicas (necesarias)</h3>
              <p className="text-sm mt-1">
                Permiten el funcionamiento básico del sitio, como recordar los productos añadidos al carrito.
                No requieren consentimiento previo. Se almacenan en el navegador (localStorage) hasta que el usuario las elimine.
              </p>
            </div>

            {usesGA && (
              <div className="bg-[#F5F1EC] p-4 rounded-lg">
                <h3 className="font-semibold">Cookies analíticas — Google Analytics 4</h3>
                <p className="text-sm mt-1">
                  Se utilizan cookies de <strong>Google Analytics</strong> (_ga, _gid, _gat) para recopilar información
                  anónima sobre el uso de la web. Estas cookies solo se activan tras tu consentimiento explícito.
                  Puedes consultar la política de privacidad de Google en{' '}
                  <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-[#785534] underline">
                    policies.google.com/privacy
                  </a>.
                </p>
              </div>
            )}

            {usesPlausible && (
              <div className="bg-[#F5F1EC] p-4 rounded-lg">
                <h3 className="font-semibold">Analítica sin cookies — Plausible</h3>
                <p className="text-sm mt-1">
                  Utilizamos <strong>Plausible Analytics</strong>, una herramienta que <strong>no utiliza cookies</strong> ni
                  recopila datos personales. No requiere consentimiento previo.
                </p>
              </div>
            )}
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">3. Cómo gestionar las cookies</h2>
          <p>
            Puedes aceptar, rechazar o revocar en cualquier momento el consentimiento para el uso de cookies a través del banner
            que aparece al acceder por primera vez a la web. Además, puedes configurar tu navegador para rechazarlas:
          </p>
          <ul className="list-disc list-inside mt-2 space-y-1">
            <li>Chrome: Configuración → Privacidad y seguridad → Cookies</li>
            <li>Firefox: Preferencias → Privacidad</li>
            <li>Safari: Preferencias → Privacidad</li>
            <li>Edge: Configuración → Cookies y permisos del sitio</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">4. Contacto</h2>
          <p>
            Para cualquier consulta relacionada con esta política puedes escribirnos a <strong>{email}</strong>.
            Titular del sitio: {owner}.
          </p>
        </section>
      </div>
    </div>
  );
}

export default CookiesPolicyPage;
